<template>
	<header>
		<div class="headingSet2">
			<h2 v-if="param_c" class="headingSet2__heading">{{{param_c}}}の検索結果一覧</h2>
			<h2 v-else class="headingSet2__heading">検索結果一覧</h2>
			<p class="headingSet2__count"><span v-text="count"></span>件</p>
		</div>
		<div v-if="scstr" class="searchCondition">
			<h3 class="searchCondition__heading">現在の検索条件</h3>
			<p v-if="scstr" v-html="scstr" class="searchCondition__condition"></p>
		</div>
		<p v-text="message"></p>
	</header>
	<div>
		<ul id="infiniteScroll" class="thumbList">
			<li v-for="item in results" transition="fade">
				<my-favoriteaction v-bind:id="item.id" v-bind:label="false" v-bind:action="true"></my-favoriteaction>
				<a v-link="item.permalink" target="_self">
					<div class="thumbList__thumb">
						<!-- <div v-my-preloadimg="{src: item.thumbnail, class: ['img-responsive', 'loadingEfect']}">
							<my-loading></my-loading>
						</div> -->
						<img v-bind:src="item.thumbnail" class="img-responsive" alt="">
					</div>
					<!--
					<div class="thumbList__icons">
						<template v-for="item2 in item.icons">
							<span v-bind:class="item2.icon" class="tooltip1 humbList__icon" title="{{item2.title}}"><span>{{item2.title}}</span></span>
						</template>
					</div>
					-->
					<p v-text="item.location" class="thumbList__area"></p>
					<p v-text="item.name" class="thumbList__name"></p>
					<p v-text="item.promoword" class="thumbList__promoword"></p>
				</a>
			</li>
		</ul>
		<div v-if="loadingEfect" id="loadingEfect">
			<my-loading></my-loading>
		</div>
		<div v-if="endOfResults" id="eor">
		</div>
		<!-- <button v-if="(p * v) / count < 1" v-on:click="moreBrowse" class="btn btn-primary">もっと見る</button> -->
	</div>
</template>

<script>
import { getSCStr, getPrefecturesList, getDistrict, getPrefectures } from '../vuex/getters';
module.exports = {
	route: {
		data: function(){
			this.$nextTick(function () {
				// ページ遷移後、頭に移動
				this.smoothScroll('body');
			});
		},
		canReuse: false
	},
	vuex: {
		getters: {
			scstr: getSCStr,
			prefecturesList: getPrefecturesList,
			district: getDistrict,
			prefectures: getPrefectures
		}
	},
	data: function () {
		return {
			pageMeta: this.$route.pageMeta,
			// w: this.$route.query.w,
			// c: this.$route.query.c,
			// scStr: this.$parent.scStr,
			searchConditionsMeta: '',
			count: '',
			p: 1,
			v: 12,
			results: [],
			message: '',
			saveMoreFlg: true,
			loadingEfect: false,
			endOfResults: false,
			param_c: ''
		};
	},
	created: function(){
		// console.log('searchresult created');
		// console.log(this.$route);

		// meta
		this.getConditionMetaJason(this.createConditionMetaJasonPath());
		var w = window.location.hash.match(/&w=(.*)$/);
		var freeWord = w[1] ? decodeURIComponent(w[1]) + ' ' : '';
		// console.log(freeWord);
		var testUnwatch = this.$watch('searchConditionsMeta', function(){
			// console.log(this.searchConditionsMeta);
			var metaObj = {
				title: freeWord + this.searchConditionsMeta + 'の検索結果' + ' | ' + this.pageMeta.title_short,
				keywords: freeWord + this.searchConditionsMeta + ' レンタル撮影スタジオ studio DATA BASE COMMERCIAL PHOTO 玄光社',
				description: freeWord + this.searchConditionsMeta + 'の検索結果。主要なスタジオを網羅したプロのためのレンタル撮影スタジオ検索サイト。白ホリからハウススタジオまで、所在地・料金・シチュエーション・設備で簡単検索。',
				url: this.pageMeta.url,
				image: this.pageMeta.image
			};
			this.setMeta(metaObj);
			testUnwatch();
		});

		// set meta
		var resulttext = freeWord ? freeWord + 'の検索結果' : '検索結果';
		var resulttext2 = freeWord ? freeWord + 'の検索結果。' : '';
		var metaObj = {
			title: resulttext + ' | ' + this.pageMeta.title_short,
			keywords: freeWord + this.pageMeta.keywords,
			description: resulttext2 + this.pageMeta.description,
			url: this.pageMeta.url,
			image: this.pageMeta.image
		};
		this.setMeta(metaObj);

		// urlのパラメータから検索条件をフィルタ
		var c = window.location.hash.match(/c=(.*)&/);
		c = c[1] ? decodeURIComponent(c[1]) + ' ' : '';
		var c_split = c.split('/');
		var c_array = [];
		for (var i = 0; i < c_split.length; i++){
			var temp = c_split[i].split(':');
			if (Number(temp[1]) === 1){
				// c_array[temp[0]] = Number(temp[1]);
				c_array.push(temp[0]);
			}
		}
		var temp_array = [];
		for (var i2 = 0; i2 < c_array.length; i2++){
			// 都道府県
			for (var prop in this.prefectures){
				if (this.prefectures[prop].id === c_array[i2]){
					temp_array.push(this.prefectures[prop].name);
				}
			}
			// 区
			for (var prop2 in this.district){
				if (this.district[prop2].id === c_array[i2]){
					temp_array.push(this.district[prop2].name);
				}
			}
		}
		if (!this.scstr){
			this.param_c = temp_array.join('&emsp;');
		}
	},
	beforeCompile: function(){
		// console.log('serchresult beforeCompile');
	},
	ready: function(){
		// console.log('searchresult ready');
		// query取得
		// console.log(this.$route.query);
		var devmode = this.devMode();
		var url = this.createJsonPath(devmode);

		// get request
		this.getJson(url, devmode);

		var self = this;
		var intervalID = window.setInterval(function(){
			var rect = document.getElementById('infiniteScroll').getBoundingClientRect();
			var requestLine = window.innerHeight - 48;

			if (self.saveMoreFlg && (self.p * self.v) / self.count < 1 && rect.bottom - requestLine <= 0){
				// console.log(rect.bottom);
				self.moreBrowse();
			} else {
				window.clearInterval(intervalID);
			}
		}, 1000);

		// ga
		// var trackingUrl = window.location.hash.replace(/^#!/, '');
		// window.ga('create', 'UA-4877520-11', 'auto');
		// window.ga('set', {
		// 	page: trackingUrl,
		// 	title: '検索結果' + ' | ' + this.pageMeta.title_short
		// });
		// window.ga('send', 'pageview');

		// scroll
		window.addEventListener('scroll', this.handleScroll);
	},
	beforeDestroy: function () {
		window.removeEventListener('scroll', this.handleScroll);
	},
	methods: {
		debug: function(){
			console.log(this.results);
		},
		devMode: function(){
			return this.$route.devmode;
		},
		createJsonPath: function(devmode){
			var host = (document.location.protocol === 'https:') ? 'https:' : 'http:';
			var hostname = document.location.hostname;
			var url = devmode ? '/static/json/sample_result.json' : host + '//' + hostname + '/s/api/search/p:' + this.p + '/v:' + this.v;
			// var url = devmode ? host + '//52.197.202.74/s/api/search/p:' + this.p + '/v:' + this.v : host + '//' + hostname + '/s/api/search/p:' + this.p + '/v:' + this.v;

			if (!devmode){
				if (this.$route.query.c){
					url += '/' + this.$route.query.c;
				}
				if (this.$route.query.w) {
					var encoded = encodeURIComponent(this.$route.query.w);
					url += '/?q=' + encoded;
				}
			}
			// console.log(url);
			return url;
		},
		getJson: function(url, devmode){
			// loading
			this.loading();

			// console.log(url);
			this.$http.get(url).then(function (response) {
				// success callback
				// console.log(response);
				var json = response.data;
				// console.log(response.data);

				// アイコン情報を追加
				var excludesIcons = ['ck_natural_light', 'ck_floor', 'ck_communication_environment', 'ck_direct_carrying', 'ck_shower_room', 'ck_flash_rental', 'ck_hmi_rental', 'ck_assistant_service', 'ck_eu_style_belong', 'ck_jp_style_belong', 'ck_multi_space', 'ck_terrace'];
				var icons = this.addIconsConf(excludesIcons);
				// var dataArray = [];
				for (var prop in json){
					if (prop !== 'count'){
						// thumbnail
						var thumbFileName = '';
						if (json[prop].Profiles.img_1){
							var imgDir = devmode ? '/static/images/sample_studio/' : '/s/img/studio/';
							thumbFileName = imgDir + json[prop].Profiles.img_1.replace(/^(.+)(\.[a-z]+)$/, '$1_thumbnail$2');
						} else {
							thumbFileName = '/static/images/thumb/no_image_r.jpg';
						}

						// icons
						var iconsArray = [];
						for (var stprop in json[prop].Studios){
							for (var iconprop in icons){
								if (stprop === iconprop && json[prop].Studios[stprop] === '1'){
									var obj = {
										icon: icons[stprop].icon,
										title: icons[stprop].title
									};
									iconsArray.push(obj);
								}
							}
						}

						// set results
						var n = this.results.length;
						this.results.$set(n, {
							id: json[prop].Profiles.id,
							permalink: 'detail/' + json[prop].Profiles.id,
							name: json[prop].Profiles.name,
							address_id: json[prop].Profiles.address_id,
							location: json[prop].Profiles.location,
							promoword: json[prop].Profiles.promoword,
							thumbnail: thumbFileName,
							icons: iconsArray
						});
					}
				}
				// console.log(dataArray);
				if (json.count === 0){
					this.message = '該当する情報がありませんでした。';
				}
				this.count = json.count;
				// this.$set('count', 200);

				// this.results配列に追加
				// this.$set('results', dataArray);

				// load complete
				this.loadComplete();
			}, function (response) {
				// error callback
				console.log(response.status);
				this.message = 'データの取得に失敗しました';
			});
		},
		createConditionMetaJasonPath: function(){
			// パラメータから検索条件の取得
			var conditions = window.location.hash.match(/c=(.*)&/);
			conditions = conditions[1].replace(/:/g, '%3A').split('%2F');
			// console.log(conditions);
			var cparams = [];
			cparams['p_st'] = '';
			cparams['sat'] = [];
			cparams['sa'] = [];

			for (var i in conditions){
				if (conditions[i].match('p_st')){
					cparams['p_st'] = conditions[i].replace('p_st%3A', '');
				} else if (conditions[i].match(/sat\d/)){
					conditions[i] = conditions[i].match(/sat(\d+)%3A/);
					cparams['sat'].push(conditions[i][1]);
				} else if (conditions[i].match(/sa\d/)){
					conditions[i] = conditions[i].match(/sa(\d+)%3A/);
					cparams['sa'].push(conditions[i][1]);
				}
			}
			cparams['p_st'] = cparams['p_st'] === '' ? 0 : cparams['p_st'];
			cparams['sat'] = cparams['sat'].length === 0 ? 0 : cparams['sat'].join('-');
			cparams['sa'] = cparams['sa'].length === 0 ? 0 : cparams['sa'].join('-');
			var paramstr = cparams['p_st'] + '/' + cparams['sat'] + '/' + cparams['sa'];
			var host = (document.location.protocol === 'https:') ? 'https:' : 'http:';
			var hostname = document.location.hostname;
			var url = host + '//' + hostname + '/s/api/get_head_search/' + paramstr;
			// console.log(url);
			return url;
		},
		getConditionMetaJason: function(url){
			// console.log(url);
			this.$http.get(url).then(function (response) {
				// success callback
				var json = response.data;
				// console.log(json);

				var cstr = [];
				if (json.Type.length !== 0){
					cstr.push(json.Type);
				}
				for (var prop in json){
					if (json[prop].hasOwnProperty('AreaTokyoCodes')){
						cstr.push(json[prop].AreaTokyoCodes.name);
					}
					if (json[prop].hasOwnProperty('AreaCodes')){
						cstr.push(json[prop].AreaCodes.name);
					}
				}
				cstr = cstr.join(' ');
				// console.log(cstr);
				this.searchConditionsMeta = cstr;
			}, function (response) {
				// error callback
				console.log(response.status);
				this.message = 'データの取得に失敗しました';
			});
		},
		moreBrowse: function(){
			// console.log('endMoreFlg: ' + this.endMoreFlg);
			this.p = this.p + 1;
			if ((this.p * this.v) - this.count < this.v){
				var devmode = this.devMode();
				var url = this.createJsonPath(devmode);
				this.getJson(url, devmode);
			}
		},
		loading: function(){
			this.$set('loadingEfect', true);
		},
		loadComplete: function(){
			// console.log('loadComplete');
			this.$set('loadingEfect', false);
			if ((this.p * this.v) - this.count >= 0){
				this.$set('endOfResults', true);
			}
		},
		handleScroll: function(e){
			var rect = document.getElementById('infiniteScroll').getBoundingClientRect();
			var requestLine = window.innerHeight - 48;

			if (this.saveMoreFlg && (this.p * this.v) / this.count < 1 && rect.bottom - requestLine <= 0){
				var self = this;
				self.moreBrowse();
				self.$set('saveMoreFlg', false);

				var timeoutID = window.setTimeout(function(){
					self.$set('saveMoreFlg', true);
					window.clearTimeout(timeoutID);
				}, 500);
			}
		}
	},
	components: {
		'my-favoriteaction': require('./favorite_action.vue')
	},
	mixins: [
		require('../mixins/setMeta.js'),
		require('../mixins/addIconsConf.js'),
		require('../mixins/getPrefectures.js'),
		require('../mixins/smoothScroll.js')
	]
};
</script>

<style scoped lang="scss">
#loadingEfect{
	position: relative;
	overflow: hidden;
	width: 100%;
	height: 48px;
}
</style>



// WEBPACK FOOTER //
// searchresult.vue?19a4f080